import {
  catchError, debounceTime, filter, from, map, mergeMap, Observable, of, takeUntil,
} from 'rxjs';
import { makeGetRequest, makePostRequest } from '../../../Common/NetworkOps';
import Config from '../../../Common/Config';
import { BidPdfDetailsResponseFormat } from './types';
import {
  BidPdfActions, getBidPdfDetailsData, getBidPdfDetailsDataFailure, getBidPdfDetailsDataSuccess,
  saveAdditionalServices,
  saveAdditionalServicesFailure,
  saveAdditionalServicesSuccess,
  setAdditionalItems,
} from './bidPdfSlice';
import { showErrorToaster, showSuccessToaster } from '../../../Common/ComponentToast/ComponentSuccessToasts';

// ---------------------------------------------------> // GET BID PDF DETAILS
async function getBidPdfDetails(data: string): Promise<BidPdfDetailsResponseFormat> {
  const url = `${Config.bids.getBidGenerationData}?JobId=${data}`;
  const result = await makeGetRequest<BidPdfDetailsResponseFormat>(url);
  return result?.data;
}

export const epicGetBidPdfDetails = (action$: Observable<BidPdfActions>) => action$.pipe(
  filter(getBidPdfDetailsData.match),
  debounceTime(250),
  map((x) => x.payload),
  mergeMap((data: string) => from(getBidPdfDetails(data)).pipe(
    map((res: BidPdfDetailsResponseFormat) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return getBidPdfDetailsDataSuccess(res?.BMT.Result);
      }
      return getBidPdfDetailsDataFailure(false);
    }),
    takeUntil(action$.pipe(filter(getBidPdfDetailsData.match))),
    catchError(() => of(getBidPdfDetailsDataFailure(false))),
  )),
);
async function saveAdditionalServicesAPI(data: object): Promise<BidPdfDetailsResponseFormat> {
  const url = `${Config.bids.saveAdditionalServices}`;
  const result = await makePostRequest<BidPdfDetailsResponseFormat>(url, data);
  return result?.data;
}

export const saveAdditionalServicesEpic = (action$: Observable<BidPdfActions>) => action$.pipe(
  filter(saveAdditionalServices.match),
  debounceTime(250),
  map((x) => x.payload),
  mergeMap((data: { pay: object, bidItems: object[] }) => from(saveAdditionalServicesAPI(data?.pay)).pipe(
    mergeMap((res: BidPdfDetailsResponseFormat) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        showSuccessToaster(res.BMT.ResponseMessage);
        return of(saveAdditionalServicesSuccess(), setAdditionalItems(data?.bidItems));
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return of(saveAdditionalServicesFailure());
    }),
    takeUntil(action$.pipe(filter(saveAdditionalServices.match))),
    catchError((error) => {
      showErrorToaster(error?.response?.data?.BMT?.ResponseMessage);
      return of(saveAdditionalServicesFailure());
    }),
  )),
);
